'use client';

import { AppShellProps } from '@saas-ui/react';

import { usePasskeyEnrolPrompt } from '@/components/features/PasskeyEnrolPrompt';
import { useDisclaimer } from '@/hooks/useDisclaimer';

import { AppLayout } from './AppLayout';

/**
 * Default sidebar layout.
 */
export const SidebarLayout: React.FC<AppShellProps> = ({
  children,
  sidebar,
  ...rest
}) => {
  useDisclaimer();
  usePasskeyEnrolPrompt();

  return (
    <AppLayout h='$100vh' sidebar={sidebar} {...rest}>
      {children}
    </AppLayout>
  );
};
